export const getResourceTypeAndPageFromUrlHash = () => {
  const hashParts = window.location.hash?.split("#")[1]?.replace("!/", "")?.split("/");
  return { name: hashParts?.[1], resourceType: hashParts?.[0] };
};
